import { useMemo } from 'react';
import { path } from 'ramda';

import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import { fn, regexp, required } from '@core/js/utils/Validation/validationRules';

import {
    useIsRetailReg
} from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/hooks/useIsRetailReg';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';

export const useCheckPhone = (t: ITranslateMethod) => {
    const isRetailReg = useIsRetailReg();
    const isPhoneMandatory = useRegistrationSelector(path(['config', 'isPhoneMandatory']));

    return useMemo(() => {
        const rules = [
            required({ error: t('mobile-required') }),
            regexp({ re: /^[0-9]+$/, error: t('mobile-regexp') }),
            fn({
                fn: (value = '') => {
                    if (!value) {
                        return;
                    }

                    const onlyDigits = value.replace(/[^0-9]*/g, '');

                    // Length check include spacers removals
                    if (onlyDigits.length !== 11) {
                        return [t('mobile-length')];
                    }

                    // No spaces at last position
                    if (value[value.length - 1] === ' ') {
                        return [t('mobile-regexp')];
                    }

                    // Phone should start with 07
                    if (!value.startsWith('07')) {
                        return [t('mobile-zero')];
                    }
                },
                error: t('mobile-required')
            })
        ];

        return isRetailReg && !isPhoneMandatory
            ? rules.slice(1)
            : rules;
    }, [isPhoneMandatory, isRetailReg, t]);
};
